import React from 'react';
import { useAsync } from 'react-async';
import ChatboxTrip from './Chatbox';
import { getTripConversationMessage } from '../../../api/trip';
import { useApp } from '../../../hooks';
import { decodeId } from '../../../utils';

export default function TripChat({
  tripId,
  conversationId,
  conversationTitle,
  conversationStatus,
  showConversationTab,
  reload,
}) {
  const { currentOrganizationId } = useApp();
  const currentOrgId = decodeId(currentOrganizationId);

  const { data, reload: messageReload } = useAsync({
    promiseFn: getTripConversationMessage,
    tripId,
    conversationId,
    watch: conversationId,
  });

  return (
    <ChatboxTrip
      messages={data?.data ?? []}
      refetch={messageReload}
      conversationReload={reload}
      tripId={tripId}
      conversationId={conversationId}
      conversationTitle={conversationTitle}
      conversationStatus={conversationStatus}
      showConversationTab={showConversationTab}
      displayAs="to"
      currentOrganizationId={currentOrgId}
    />
  );
}
